import { MenuItem, TextField } from '@mui/material'
import { Language } from '@shared/types/users.types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '../hooks/useAuthStore'
import { useUserUpdateMutation } from '../hooks/useMutations/useUsersMutations'

export default function LanguageSelector() {
  const { t, i18n } = useTranslation()
  const [language, setLanguage] = useState(i18n.language)
  const { userId } = useAuthStore()
  const updateLanguage = useUserUpdateMutation()
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedLanguage = event.target.value
    setLanguage(selectedLanguage)
    i18n.changeLanguage(selectedLanguage)
    if (userId) {
      updateLanguage.mutate({
        userId,
        user: { language: selectedLanguage as Language }
      })
    }
  }
  return (
    <>
      <TextField
        select
        label={t('user.language')}
        variant='filled'
        value={language}
        onChange={handleChange}
        fullWidth
        sx={{
          background: 'text.secondary',
          '& .MuiFilledInput-root': {
            '&:before': { borderBottom: 'none' },
            '&:after': { borderBottom: 'none' },
            '&:hover:before': { borderBottom: 'none' }
          }
        }}
      >
        <MenuItem value='es'>Español</MenuItem>
      </TextField>
    </>
  )
}
